import React, { PureComponent } from 'react';
import { Dropdown, Label } from 'semantic-ui-react';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';

export default class DLSelect extends PureComponent {
    renderLabel = ( item, index, defaultLabelProps ) => {
        return (
            <Label { ...defaultLabelProps }
            removeIcon={ <Icon source='fontAwesome' className='delete' icon='fas/faTimesCircle' /> }
            content={ item.text } />
        );
    }


    
    render() {
        const inlineStyle = { ...this.props.style };
        const icon = this.props.icon || ( <Icon source='fontAwesome' className='dropdown' icon='fas/faSort' /> );

        return (
            <div className={ `semantic-wrapper ${ style.semanticSelectField } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            data-name={ this.props.name }
            style={ inlineStyle }>
                { this.props.label &&
                    <label>{ this.props.label }</label>
                }
                <Dropdown className={ `${ style.semanticDropdown }` }
                value={ this.props.value }
                name={ this.props.name }
                autoFocus={ this.props.autoFocus }
                onChange={ this.props.onChange }
                onFocus={ this.props.onFocus }
                onBlur={ this.props.onBlur }
                required={ this.props.required }
                placeholder={ this.props.placeholder }
                error={ !!this.props.error }
                icon={ icon }
                multiple={ this.props.multiple }
                options={ this.props.options }
                renderLabel={ this.renderLabel }
                fluid
                selection />
                { this.props.hintMessage &&
                    <p className='hint-message'>{ this.props.hintMessage }</p>
                }
                { !this.props.noError &&
                    <p className='error-message'>{ this.props.error }</p>
                }
            </div>
        );
    }
}

DLSelect.defaultProps = {
    className: '',
    style: {},
    options: [],
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
};
